import React from 'react';

export const VomitingEmoji = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.998 26.5408C22.2112 26.5408 27.248 21.504 27.248 15.2908C27.248 9.07757 22.2112 4.04077 15.998 4.04077C9.78484 4.04077 4.74805 9.07757 4.74805 15.2908C4.74805 21.504 9.78484 26.5408 15.998 26.5408Z"
        fill="url(#paint0_radial_10778_868)"
      />
      <path
        d="M15.998 26.5408C22.2112 26.5408 27.248 21.504 27.248 15.2908C27.248 9.07757 22.2112 4.04077 15.998 4.04077C9.78484 4.04077 4.74805 9.07757 4.74805 15.2908C4.74805 21.504 9.78484 26.5408 15.998 26.5408Z"
        fill="url(#paint1_radial_10778_868)"
      />
      <path
        d="M16.0039 26.5098C22.2171 26.5098 27.2539 21.473 27.2539 15.2598C27.2539 9.04656 22.2171 4.00977 16.0039 4.00977C9.7907 4.00977 4.75391 9.04656 4.75391 15.2598C4.75391 21.473 9.7907 26.5098 16.0039 26.5098Z"
        fill="url(#paint2_radial_10778_868)"
        fillOpacity="0.8"
      />
      <path
        d="M16.0039 4.00977C9.79071 4.00977 4.75391 9.04656 4.75391 15.2598C4.75391 21.473 9.7907 26.5098 16.0039 26.5098C22.2171 26.5098 27.2539 21.473 27.2539 15.2598C27.2539 9.04656 22.2171 4.00977 16.0039 4.00977Z"
        fill="url(#paint3_radial_10778_868)"
        fillOpacity="0.8"
      />
      <g opacity="0.4" filter="url(#filter0_f_10778_868)">
        <path
          d="M21.7792 7.71065C21.7792 9.32575 19.2136 10.635 16.0488 10.635C12.8839 10.635 10.3184 9.32575 10.3184 7.71065C10.3184 6.09555 12.8839 4.78625 16.0488 4.78625C19.2136 4.78625 21.7792 6.09555 21.7792 7.71065Z"
          fill="url(#paint4_radial_10778_868)"
        />
      </g>
      <path
        d="M9.90234 20.0922C9.90234 16.5752 13.8562 15.5539 16.0003 15.5542C18.1444 15.5544 22.0983 16.5752 22.0983 20.0922C22.0983 22.4069 19.934 24.3683 16.1614 24.3683C12.3888 24.3683 9.90234 22.4429 9.90234 20.0922Z"
        fill="url(#paint5_radial_10778_868)"
      />
      <path
        d="M9.90234 20.0922C9.90234 16.5752 13.8562 15.5539 16.0003 15.5542C18.1444 15.5544 22.0983 16.5752 22.0983 20.0922C22.0983 22.4069 19.934 24.3683 16.1614 24.3683C12.3888 24.3683 9.90234 22.4429 9.90234 20.0922Z"
        fill="#3F1C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9356 16.1214C13.2727 15.3819 14.8748 15.1166 16.0004 15.1167C17.1259 15.1168 18.7279 15.3821 20.0651 16.1215C21.4186 16.87 22.5358 18.1314 22.5358 20.0922C22.5358 22.748 20.0624 24.8058 16.1614 24.8058C14.2045 24.8058 12.5461 24.3068 11.3641 23.4687C10.1787 22.6281 9.46484 21.4359 9.46484 20.0922C9.46484 18.1314 10.5821 16.8699 11.9356 16.1214ZM16.0003 15.5542C13.8562 15.5539 9.90234 16.5752 9.90234 20.0922C9.90234 22.4429 12.3888 24.3683 16.1614 24.3683C19.934 24.3683 22.0983 22.4069 22.0983 20.0922C22.0983 16.5752 18.1444 15.5544 16.0003 15.5542Z"
        fill="url(#paint6_linear_10778_868)"
      />
      <path
        d="M11.5945 10.3359C13.8092 10.88 14.5476 11.7877 14.2169 12.6145C13.6091 14.134 11.0845 13.0248 8.30535 14.4296C7.97791 14.5951 7.762 14.2596 8.01547 14.0015C9.03895 12.9594 10.6042 12.321 12.3525 12.1319C11.6489 10.954 8.30089 11.01 8.01547 11.0236C7.73005 11.0372 7.61727 10.6806 7.90016 10.5212C8.18306 10.3618 9.53338 9.82948 11.5945 10.3359Z"
        fill="#421D30"
      />
      <path
        d="M20.4075 10.3359C18.1927 10.88 17.4543 11.7877 17.785 12.6145C18.3928 14.134 20.9175 13.0248 23.6966 14.4296C24.024 14.5951 24.24 14.2596 23.9865 14.0015C22.963 12.9594 21.3978 12.321 19.6495 12.1319C20.353 10.954 23.7011 11.01 23.9865 11.0236C24.2719 11.0372 24.3847 10.6806 24.1018 10.5212C23.8189 10.3618 22.4686 9.82948 20.4075 10.3359Z"
        fill="#421D30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3534 11.8752C17.27 12.1806 17.2955 12.4871 17.41 12.7733C17.6159 13.2882 17.995 13.5778 18.448 13.7409C18.8732 13.894 19.3866 13.9437 19.8991 13.9865C19.9539 13.9911 20.0093 13.9957 20.065 14.0003C21.0845 14.084 22.2531 14.18 23.4764 14.7983C23.7881 14.9558 24.1821 14.9146 24.3931 14.5961C24.5929 14.2944 24.5049 13.9236 24.2687 13.6831C23.3808 12.779 22.1359 12.1745 20.7464 11.871C21.1155 11.7299 21.5663 11.6341 22.0242 11.5714C22.9429 11.4456 23.8154 11.4626 23.9387 11.4685C24.2855 11.485 24.5664 11.2646 24.6468 10.962C24.7294 10.6509 24.5862 10.3285 24.2865 10.1596C23.9128 9.94901 22.4616 9.40357 20.3085 9.93257C19.1799 10.2098 18.3634 10.5933 17.8678 11.0632C17.6159 11.302 17.4357 11.5741 17.3534 11.8752ZM20.0429 11.7447C21.154 10.9798 23.7124 11.0236 23.9593 11.0353C24.2422 11.0488 24.354 10.6954 24.0736 10.5374C23.7932 10.3794 22.4548 9.85177 20.4119 10.3537C18.2167 10.893 17.4848 11.7928 17.8126 12.6122C18.1305 13.407 18.9774 13.4762 20.1113 13.5689C21.1262 13.6519 22.371 13.7537 23.672 14.4113C23.9966 14.5753 24.2106 14.2428 23.9593 13.987C23.0439 13.0549 21.6913 12.4486 20.1626 12.2014C19.9973 12.1747 19.8298 12.1522 19.6606 12.1339C19.7494 11.9852 19.8807 11.8563 20.0429 11.7447Z"
        fill="url(#paint7_linear_10778_868)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6739 11.8752C14.7573 12.1806 14.7319 12.4871 14.6174 12.7733C14.4114 13.2882 14.0324 13.5778 13.5793 13.7409C13.1542 13.894 12.6408 13.9437 12.1283 13.9865C12.0734 13.9911 12.0181 13.9957 11.9623 14.0003C10.9428 14.084 9.77425 14.18 8.55096 14.7983C8.23924 14.9558 7.84526 14.9146 7.63425 14.5961C7.43443 14.2944 7.52248 13.9236 7.75864 13.6831C8.64656 12.779 9.89146 12.1745 11.281 11.871C10.9118 11.7299 10.4611 11.6341 10.0031 11.5714C9.08449 11.4456 8.21193 11.4626 8.08865 11.4685C7.7418 11.485 7.4609 11.2646 7.38053 10.962C7.29793 10.6509 7.44112 10.3285 7.74083 10.1596C8.11452 9.94901 9.56577 9.40357 11.7189 9.93257C12.8474 10.2098 13.6639 10.5933 14.1596 11.0632C14.4114 11.302 14.5917 11.5741 14.6739 11.8752ZM11.9844 11.7447C10.8734 10.9798 8.3149 11.0236 8.06802 11.0353C7.78512 11.0488 7.67333 10.6954 7.95373 10.5374C8.23413 10.3794 9.57254 9.85177 11.6154 10.3537C13.8107 10.893 14.5425 11.7928 14.2148 12.6122C13.8969 13.407 13.0499 13.4762 11.916 13.5689C10.9011 13.6519 9.65637 13.7537 8.35534 14.4113C8.03079 14.5753 7.81679 14.2428 8.06802 13.987C8.98342 13.0549 10.3361 12.4486 11.8647 12.2014C12.0301 12.1747 12.1976 12.1522 12.3667 12.1339C12.2779 11.9852 12.1466 11.8563 11.9844 11.7447Z"
        fill="url(#paint8_linear_10778_868)"
      />
      <path
        d="M20.0723 22.222C20.1497 22.8497 20.2505 23.4135 20.3816 23.8555C20.4848 24.1442 20.977 24.338 21.5133 24.5491C22.5275 24.9484 23.4785 25.6913 22.694 26.6922C22.0629 27.4974 19.3717 27.7223 18.6681 27.2798C18.552 27.5337 17.8281 28.3641 15.8608 28.3641C13.8935 28.3641 13.1696 27.5337 13.0535 27.2798C12.3499 27.7223 9.65868 27.4974 9.0276 26.6922C8.39653 25.887 9.2405 24.9506 10.2892 24.5519C10.8474 24.3397 11.3583 24.1455 11.462 23.8555C11.6795 23.0648 11.8819 21.3969 11.9634 19.7569C12.0121 18.7779 12.0177 17.8088 11.9576 17.0423C11.9467 16.9025 11.9393 16.7599 11.9469 16.6204C13.2385 15.8376 14.8708 15.5541 16.0006 15.5542C17.054 15.5543 18.5443 15.8008 19.7878 16.4686C19.8133 16.5956 19.8198 16.7276 19.8202 16.8585C19.8237 18.0295 19.8478 19.619 19.9595 21.0712C19.99 21.4689 20.0272 21.8563 20.0723 22.222Z"
        fill="url(#paint9_radial_10778_868)"
      />
      <path
        d="M20.0723 22.222C20.1497 22.8497 20.2505 23.4135 20.3816 23.8555C20.4848 24.1442 20.977 24.338 21.5133 24.5491C22.5275 24.9484 23.4785 25.6913 22.694 26.6922C22.0629 27.4974 19.3717 27.7223 18.6681 27.2798C18.552 27.5337 17.8281 28.3641 15.8608 28.3641C13.8935 28.3641 13.1696 27.5337 13.0535 27.2798C12.3499 27.7223 9.65868 27.4974 9.0276 26.6922C8.39653 25.887 9.2405 24.9506 10.2892 24.5519C10.8474 24.3397 11.3583 24.1455 11.462 23.8555C11.6795 23.0648 11.8819 21.3969 11.9634 19.7569C12.0121 18.7779 12.0177 17.8088 11.9576 17.0423C11.9467 16.9025 11.9393 16.7599 11.9469 16.6204C13.2385 15.8376 14.8708 15.5541 16.0006 15.5542C17.054 15.5543 18.5443 15.8008 19.7878 16.4686C19.8133 16.5956 19.8198 16.7276 19.8202 16.8585C19.8237 18.0295 19.8478 19.619 19.9595 21.0712C19.99 21.4689 20.0272 21.8563 20.0723 22.222Z"
        fill="url(#paint10_linear_10778_868)"
        fillOpacity="0.6"
      />
      <path
        d="M18.6681 27.2798C19.3717 27.7223 22.0629 27.4975 22.694 26.6923C23.0621 26.2646 22.9751 25.8392 22.9557 25.7548C22.5982 27.2797 19.3717 26.9723 18.6681 26.5298C18.552 26.7837 17.8281 27.6767 15.8608 27.6767C13.8935 27.6767 13.1696 26.7837 13.0535 26.5298C12.3499 26.9723 8.87726 27.2194 8.87726 25.7548C8.76102 26.0618 8.78793 26.3865 9.0276 26.6923C9.65868 27.4975 12.3499 27.7223 13.0535 27.2798C13.1696 27.5337 13.8935 28.3642 15.8608 28.3642C17.8281 28.3642 18.552 27.5337 18.6681 27.2798Z"
        fill="#0BBB08"
      />
      <path
        d="M13.1807 20.9727C13.1254 22.0858 12.9894 23.2175 12.8422 23.7742C12.8421 23.7742 12.8422 23.7742 12.8422 23.7742C12.8396 23.7838 12.8371 23.7932 12.8346 23.8025C12.763 24.0027 12.4102 24.1368 12.0248 24.2833C11.3008 24.5586 10.7181 25.2051 11.1538 25.761C11.5895 26.317 13.4476 26.4722 13.9334 26.1667C14.0135 26.342 14.5133 26.9154 15.8716 26.9154C17.2299 26.9154 17.7297 26.342 17.8099 26.1667C18.2957 26.4722 20.1538 26.317 20.5895 25.761C21.1311 25.07 20.4745 24.5571 19.7743 24.2813C19.404 24.1356 19.0642 24.0018 18.9929 23.8025C18.9024 23.4973 18.8328 23.108 18.7793 22.6746C18.7482 22.4222 18.7226 22.1547 18.7015 21.8801C18.7007 21.8702 18.6999 21.8602 18.6992 21.8502C18.559 19.899 18.6143 17.927 18.604 15.9714C17.6781 15.6737 16.7333 15.5543 16.0001 15.5542C15.2074 15.5541 14.1672 15.6937 13.171 16.0474C13.1854 17.6859 13.2621 19.3349 13.1807 20.9727Z"
        fill="url(#paint11_radial_10778_868)"
      />
      <path
        d="M13.1807 20.9727C13.1254 22.0858 12.9894 23.2175 12.8422 23.7742C12.8421 23.7742 12.8422 23.7742 12.8422 23.7742C12.8396 23.7838 12.8371 23.7932 12.8346 23.8025C12.763 24.0027 12.4102 24.1368 12.0248 24.2833C11.3008 24.5586 10.7181 25.2051 11.1538 25.761C11.5895 26.317 13.4476 26.4722 13.9334 26.1667C14.0135 26.342 14.5133 26.9154 15.8716 26.9154C17.2299 26.9154 17.7297 26.342 17.8099 26.1667C18.2957 26.4722 20.1538 26.317 20.5895 25.761C21.1311 25.07 20.4745 24.5571 19.7743 24.2813C19.404 24.1356 19.0642 24.0018 18.9929 23.8025C18.9024 23.4973 18.8328 23.108 18.7793 22.6746C18.7482 22.4222 18.7226 22.1547 18.7015 21.8801C18.7007 21.8702 18.6999 21.8602 18.6992 21.8502C18.559 19.899 18.6143 17.927 18.604 15.9714C17.6781 15.6737 16.7333 15.5543 16.0001 15.5542C15.2074 15.5541 14.1672 15.6937 13.171 16.0474C13.1854 17.6859 13.2621 19.3349 13.1807 20.9727Z"
        fill="url(#paint12_linear_10778_868)"
        fillOpacity="0.6"
      />
      <path
        opacity="0.7"
        d="M18.9831 25.0345C18.9831 25.6148 17.6175 26.0851 15.9329 26.0851C14.2484 26.0851 12.8828 25.6148 12.8828 25.0345C12.8828 24.4543 14.2484 23.9839 15.9329 23.9839C17.6175 23.9839 18.9831 24.4543 18.9831 25.0345Z"
        fill="url(#paint13_radial_10778_868)"
      />
      <path
        opacity="0.8"
        d="M15.0078 19.61C15.0078 19.3364 14.7258 18.8497 14.5658 18.5956C14.5162 18.5169 14.4041 18.5195 14.3582 18.6003C14.2105 18.8602 13.9512 19.3558 13.9512 19.6325C13.9571 19.9139 14.1986 20.1372 14.4903 20.1308C14.782 20.1246 15.0137 19.8914 15.0077 19.6099L15.0078 19.61Z"
        fill="url(#paint14_radial_10778_868)"
      />
      <path
        opacity="0.8"
        d="M17.7089 22.8248C17.7089 22.5513 17.4269 22.0646 17.2669 21.8104C17.2174 21.7317 17.1053 21.7343 17.0594 21.8151C16.9117 22.075 16.6523 22.5707 16.6523 22.8473C16.6583 23.1287 16.8997 23.3521 17.1915 23.3457C17.4832 23.3395 17.7149 23.1062 17.7089 22.8247L17.7089 22.8248Z"
        fill="url(#paint15_radial_10778_868)"
      />
      <path
        opacity="0.8"
        d="M17.7714 17.9018C17.7714 17.6283 17.4894 17.1416 17.3294 16.8874C17.2799 16.8088 17.1678 16.8113 17.1219 16.8922C16.9742 17.1521 16.7148 17.6477 16.7148 17.9244C16.7208 18.2058 16.9622 18.4291 17.254 18.4227C17.5457 18.4165 17.7774 18.1832 17.7714 17.9018L17.7714 17.9018Z"
        fill="url(#paint16_radial_10778_868)"
      />
      <path
        d="M14.0805 23.2762C14.0805 23.0783 13.9766 21.6113 13.8936 20.7057C13.8864 20.6274 13.7088 20.6279 13.7022 20.7063C13.6257 21.6158 13.541 23.0926 13.541 23.2932C13.5441 23.5062 13.6673 23.6753 13.8163 23.6704C13.9652 23.6657 14.0836 23.4892 14.0805 23.2762Z"
        fill="url(#paint17_linear_10778_868)"
      />
      <path
        d="M19.6101 22.8475C19.5903 22.6506 19.3501 21.2003 19.1848 20.3068C19.1705 20.2295 19.0106 20.2461 19.0124 20.3247C19.0344 21.2366 19.1057 22.7136 19.1258 22.9133C19.1498 23.1249 19.2778 23.282 19.4115 23.2637C19.5452 23.2455 19.6342 23.0592 19.6101 22.8475Z"
        fill="url(#paint18_linear_10778_868)"
      />
      <path
        opacity="0.6"
        d="M12.7885 18.8073C12.7909 18.6741 12.733 17.6857 12.6834 17.0752C12.6791 17.0224 12.5489 17.0204 12.5431 17.073C12.4758 17.684 12.3955 18.6765 12.393 18.8115C12.3926 18.9548 12.4808 19.0702 12.59 19.069C12.6992 19.0678 12.7881 18.9507 12.7885 18.8073Z"
        fill="url(#paint19_linear_10778_868)"
      />
      <path
        opacity="0.9"
        d="M16.2309 20.7323C16.2309 20.4537 16.127 18.3884 16.044 17.1135C16.0368 17.0032 15.8592 17.0039 15.8526 17.1142C15.7761 18.3947 15.6914 20.4738 15.6914 20.7563C15.6945 21.0562 15.8177 21.2942 15.9667 21.2874C16.1156 21.2808 16.234 21.0323 16.2309 20.7323Z"
        fill="url(#paint20_linear_10778_868)"
      />
      <defs>
        <filter
          id="filter0_f_10778_868"
          x="7.48634"
          y="1.95423"
          width="17.125"
          height="11.5129"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.41601"
            result="effect1_foregroundBlur_10778_868"
          />
        </filter>
        <radialGradient
          id="paint0_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.6681 5.38675) scale(21.0305)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.43" stopColor="#FFD400" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FF8E00" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(12.8919 18.2106 -18.2098 12.8488 10.9037 5.81006)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.608798" stopColor="#FFE437" stopOpacity="0" />
          <stop offset="0.858784" stopColor="#FF79B1" stopOpacity="0.45" />
          <stop offset="0.994222" stopColor="#FF3673" stopOpacity="0.56" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0039 15.772) rotate(-90) scale(12.3762 11.8236)"
        >
          <stop offset="0.848958" stopColor="#FFC60C" stopOpacity="0" />
          <stop offset="1" stopColor="#FF7039" stopOpacity="0.68" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0039 14.7475) rotate(90) scale(11.7623 11.6637)"
        >
          <stop offset="0.847356" stopColor="#FE789B" stopOpacity="0" />
          <stop offset="1" stopColor="#F11414" stopOpacity="0.41" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0488 7.71065) rotate(89.9999) scale(2.92439 5.37628)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#FFED49" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.2664 32.8215) scale(13.265 20.8507)"
        >
          <stop offset="0.52" stopColor="#A8360D" />
          <stop offset="1" stopColor="#2E0C00" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_10778_868"
          x1="16.0003"
          y1="15.5542"
          x2="16.0003"
          y2="24.3683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD9E28" stopOpacity="0.7" />
          <stop offset="1" stopColor="#FFF2B7" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_10778_868"
          x1="21.4116"
          y1="10.142"
          x2="20.1629"
          y2="13.6969"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FADE55" stopOpacity="0" />
          <stop offset="0.846096" stopColor="#FFE794" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_10778_868"
          x1="10.6158"
          y1="10.142"
          x2="11.8644"
          y2="13.6969"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FADE55" stopOpacity="0" />
          <stop offset="0.846096" stopColor="#FFE794" />
        </linearGradient>
        <radialGradient
          id="paint9_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.8608 26.0356) rotate(0.958432) scale(10.8621 7.05012)"
        >
          <stop stopColor="#78EF00" />
          <stop offset="0.330537" stopColor="#4FF500" />
          <stop offset="0.895302" stopColor="#03AE00" />
        </radialGradient>
        <linearGradient
          id="paint10_linear_10778_868"
          x1="15.8657"
          y1="15.5542"
          x2="15.8657"
          y2="21.3826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#083600" />
          <stop offset="1" stopColor="#83F93B" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint11_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.8966 23.3624) rotate(-90) scale(7.62255 5.27959)"
        >
          <stop offset="0.3" stopColor="#8BFF3F" />
          <stop offset="1" stopColor="#2BF700" />
        </radialGradient>
        <linearGradient
          id="paint12_linear_10778_868"
          x1="15.875"
          y1="15.6668"
          x2="15.875"
          y2="21.9966"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0915033" stopColor="#117C00" />
          <stop offset="1" stopColor="#83F93B" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint13_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.9329 25.0345) rotate(90) scale(1.05076 3.05053)"
        >
          <stop stopColor="#D9FFCC" />
          <stop offset="1" stopColor="#84FE3A" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.4795 18.5381) rotate(90) scale(1.50117)"
        >
          <stop stopColor="#4BE419" stopOpacity="0" />
          <stop offset="0.789725" stopColor="#B0FF8A" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.1806 21.7529) rotate(90) scale(1.50117)"
        >
          <stop stopColor="#55E000" stopOpacity="0" />
          <stop offset="0.6875" stopColor="#B8FF97" />
        </radialGradient>
        <radialGradient
          id="paint16_radial_10778_868"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.2431 16.83) rotate(90) scale(1.50117)"
        >
          <stop stopColor="#4BE419" stopOpacity="0" />
          <stop offset="0.789725" stopColor="#71FF1B" />
        </radialGradient>
        <linearGradient
          id="paint17_linear_10778_868"
          x1="13.8108"
          y1="20.8686"
          x2="13.9473"
          y2="23.4847"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55E91F" stopOpacity="0" />
          <stop offset="1" stopColor="#44F02C" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_10778_868"
          x1="19.1265"
          y1="20.4764"
          x2="19.5377"
          y2="23.0628"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55E91F" stopOpacity="0" />
          <stop offset="1" stopColor="#4BF134" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_10778_868"
          x1="12.6207"
          y1="17.1837"
          x2="12.6727"
          y2="18.9463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55E91F" stopOpacity="0" />
          <stop offset="1" stopColor="#39D724" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_10778_868"
          x1="15.9612"
          y1="17.3428"
          x2="16.231"
          y2="21.0162"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55E91F" stopOpacity="0" />
          <stop offset="1" stopColor="#41E12B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
